export default "__VITE_ASSET__BqLlwsN0__"